"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require("reactstrap");

var _AbstractField2 = require("./AbstractField");

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

require("./ListSelectField.scss");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Komponenta seznamu položek s možností jednu vybrat. Jedná se o standardní field s onChange metodou.
 */
var ListSelectField = function (_AbstractField) {
    (0, _inherits3.default)(ListSelectField, _AbstractField);

    function ListSelectField() {
        (0, _classCallCheck3.default)(this, ListSelectField);
        return (0, _possibleConstructorReturn3.default)(this, (ListSelectField.__proto__ || (0, _getPrototypeOf2.default)(ListSelectField)).apply(this, arguments));
    }

    (0, _createClass3.default)(ListSelectField, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                renderItem = _props.renderItem,
                className = _props.className,
                idAttrName = _props.idAttrName,
                onChange = _props.onChange,
                value = _props.value,
                items = _props.items;


            var cls = (0, _classnames2.default)("list-select-field", className);

            var field = _react2.default.createElement(
                _reactstrap.ListGroup,
                { className: cls },
                items.map(function (item) {
                    var active = void 0;
                    if (value != null) {
                        if (item[idAttrName] != null && value[idAttrName] != null) {
                            active = item === value;
                        } else {
                            active = item[idAttrName] === value[idAttrName];
                        }
                    }
                    return _react2.default.createElement(
                        _reactstrap.ListGroupItem,
                        { active: active, onClick: function onClick() {
                                onChange && onChange(item);
                            } },
                        renderItem(item)
                    );
                })
            );

            return this.renderFieldWithAddons(field);
        }
    }]);
    return ListSelectField;
}(_AbstractField3.default); // --


ListSelectField.PropTypes = {
    items: _react2.default.PropTypes.array.isRequired, // seznam položek
    idAttrName: _react2.default.PropTypes.string, // název atributu pro určení id
    renderItem: _react2.default.PropTypes.func // render řádku
};
ListSelectField.defaultProps = {
    idAttrName: "id",
    renderItem: function renderItem(x) {
        return x.name;
    }
};
exports.default = ListSelectField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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